import { useMutation } from "@blitzjs/rpc"
import logout from "app/auth/mutations/logout"
import { june } from "app/misc/june"
import { deleteCookie } from "blitz"
import { useRouter } from "next/router"
import { useIntercom } from "react-use-intercom"

const useLogout = () => {
  const router = useRouter()
  const [logoutMutation] = useMutation(logout)
  const intercom = useIntercom()

  return async () => {
    await logoutMutation()
    deleteCookie("_sw_admin_hint")

    // Reset the june identity
    if (june) {
      june.reset()
    }

    // Reset the intercom identity
    intercom.shutdown()
    console.log("[!] logged out intercom", intercom)

    // router.push("/api/auth/logout")
  }
}
export default useLogout
